var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { Tooltip } from 'react-leaflet';
const MapLeafletGeofenceTooltip = (props) => {
    const { value } = props, rest = __rest(props, ["value"]);
    return (React.createElement(Tooltip, Object.assign({ direction: 'top', className: 'leaflet-tooltip-top-geofence' }, rest),
        React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                fontSize: '12px',
                bgcolor: 'background.paper',
                overflow: 'hidden',
                borderRadius: theme.shape.borderRadius,
            }) },
            React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    padding: '4px 6px',
                    bgcolor: 'background.paper',
                    color: theme.palette.common.black,
                    '.MuiTypography-root': {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        fontSize: '12px',
                    },
                }) },
                React.createElement(Typography, { variant: 'body1' }, value.short_name)))));
};
export default MapLeafletGeofenceTooltip;
